import { useEffect } from 'react';
import { Portal } from '@vfit/shared/components';
import { Modal } from '@vfit/shared/atoms';
import { I_ConsumerVodafoneModalProps } from './consumerVodafoneModal.models';
import {
  ConsumerModalBody,
  ConsumerModalContent,
  ConsumerModalScrollableContent,
  ModalText,
  ModalTitle,
} from './consumerVodafoneModal.style';

const ConsumerVodafoneModal = ({
  isModalShown,
  onCloseModal,
  height,
  children,
  tabletMode,
  wrapperId,
  isDisabledClose,
  enableCloseClickOutside,
  closeColor,
  variant = 'sunrise',
  dataName, // for automation testing
  purifiedModalTitle,
  purifiedModalText,
}: I_ConsumerVodafoneModalProps) => {
  useEffect(() => {
    if (!isModalShown) return;

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onCloseModal?.();
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isModalShown, onCloseModal]);

  return (
    <Portal wrapperId="coverage-tool">
      <Modal
        customId={wrapperId}
        withBorderRadius
        show={isModalShown}
        onCloseModal={onCloseModal}
        isDisabledClose={isDisabledClose}
        height={height}
        tabletMode={tabletMode}
        isModalFullContainer
        enableCloseClickOutside={enableCloseClickOutside}
        closeColor={closeColor}
        variant={variant}
        dataName={dataName}
      >
        <ConsumerModalContent>
          <ConsumerModalBody>
            {purifiedModalTitle && (
              <ModalTitle
                dangerouslySetInnerHTML={{
                  __html: purifiedModalTitle,
                }}
              />
            )}

            <ConsumerModalScrollableContent>
              {purifiedModalText && (
                <ModalText
                  dangerouslySetInnerHTML={{
                    __html: purifiedModalText,
                  }}
                />
              )}

              {children}
            </ConsumerModalScrollableContent>
          </ConsumerModalBody>
        </ConsumerModalContent>
      </Modal>
    </Portal>
  );
};

export default ConsumerVodafoneModal;

